module.exports = __webpack_public_path__ + "static/media/achievement-planking-challenge.14580e8b.svg";